import { useMemo } from "react";

const MOBILE_REGEX =
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;

function detectMobile(): boolean {
  if (typeof navigator === "undefined") return false;
  return MOBILE_REGEX.test(navigator.userAgent);
}

export function useIsMobile(): boolean {
  return useMemo(() => detectMobile(), []);
}
